'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HandleHideNavItem = exports.Fixed = exports.StyledP = undefined;

var _IconMenu2 = require('mcs-lite-icon/lib/IconMenu');

var _IconMenu3 = _interopRequireDefault(_IconMenu2);

var _IconClose2 = require('mcs-lite-icon/lib/IconClose');

var _IconClose3 = _interopRequireDefault(_IconClose2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  margin-right: 5px;\n'], ['\n  margin-right: 5px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['position:fixed;top:0;bottom:0;left:0;right:0;background-image:linear-gradient( 0deg,rgba(250,250,250,0.9) 0%,#ffffff 100% );padding-top:', ';overflow:auto;> *:last-child{box-shadow:0 1px 0 0 rgba(0,0,0,0.05);}'], ['position:fixed;top:0;bottom:0;left:0;right:0;background-image:linear-gradient( 0deg,rgba(250,250,250,0.9) 0%,#ffffff 100% );padding-top:', ';overflow:auto;> *:last-child{box-shadow:0 1px 0 0 rgba(0,0,0,0.05);}']),
    _templateObject3 = _taggedTemplateLiteral(['display:flex;align-items:center;justify-content:center;&:not(a){box-shadow:0 1px 0 0 rgba(0,0,0,0.05);margin:0 50px;}'], ['display:flex;align-items:center;justify-content:center;&:not(a){box-shadow:0 1px 0 0 rgba(0,0,0,0.05);margin:0 50px;}']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rafThrottle = require('raf-throttle');

var _rafThrottle2 = _interopRequireDefault(_rafThrottle);

var _Portal = require('react-overlays/lib/Portal');

var _Portal2 = _interopRequireDefault(_Portal);

var _reactMotionUiPack = require('react-motion-ui-pack');

var _reactMotionUiPack2 = _interopRequireDefault(_reactMotionUiPack);

var _spring = require('react-motion/lib/spring');

var _spring2 = _interopRequireDefault(_spring);

var _MorphReplace = require('../MorphReplace');

var _MorphReplace2 = _interopRequireDefault(_MorphReplace);

var _P = require('../P');

var _P2 = _interopRequireDefault(_P);

var _NavItem = require('./NavItem');

var _NavItem2 = _interopRequireDefault(_NavItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* global window, document */

var StyledP = exports.StyledP = _P2.default.extend(_templateObject);

var Fixed = exports.Fixed = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.theme.height.header;
});

var StyledNavItem = (0, _styledComponents2.default)(_NavItem2.default)(_templateObject3);

var HandleHideNavItem = function HandleHideNavItem(_ref) {
  var onHide = _ref.onHide,
      _onClick = _ref.onClick,
      disabled = _ref.disabled,
      otherProps = _objectWithoutProperties(_ref, ['onHide', 'onClick', 'disabled']);

  return _react2.default.createElement(StyledNavItem, Object.assign({}, otherProps, {
    disabled: disabled,
    onClick: function onClick(e) {
      if (_onClick) _onClick(e);
      if (!disabled) onHide(e);
    }
  }));
};
exports.HandleHideNavItem = HandleHideNavItem;
HandleHideNavItem.displayName = 'HandleHideNavItem';
HandleHideNavItem.propTypes = {
  onHide: _propTypes2.default.func.isRequired,
  onClick: _propTypes2.default.func,
  disabled: _propTypes2.default.bool
};

var NavItemBurger = function (_React$PureComponent) {
  _inherits(NavItemBurger, _React$PureComponent);

  function NavItemBurger() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, NavItemBurger);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = NavItemBurger.__proto__ || Object.getPrototypeOf(NavItemBurger)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { isShow: false }, _this.componentDidMount = function () {
      window.addEventListener('resize', _this.onHide);
    }, _this.componentWillUnmount = function () {
      window.removeEventListener('resize', _this.onHide);
      _this.onHide.cancel();
    }, _this.onClick = function () {
      return _this.setState({ isShow: !_this.state.isShow });
    }, _this.onHide = (0, _rafThrottle2.default)(function () {
      if (_this.state.isShow) _this.setState({ isShow: false });
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavItemBurger, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // TODO: dont do this
      if (prevState.isShow !== this.state.isShow) {
        document.body.style.overflow = this.state.isShow ? 'hidden' : 'auto';
        document.documentElement.style.overflow = this.state.isShow ? 'hidden' : 'auto';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var onClick = this.onClick,
          onHide = this.onHide;
      var isShow = this.state.isShow;

      var _props = this.props,
          children = _props.children,
          items = _props.items,
          otherProps = _objectWithoutProperties(_props, ['children', 'items']);

      return _react2.default.createElement(
        _NavItem2.default,
        Object.assign({ onClick: onClick }, otherProps),
        children && _react2.default.createElement(
          StyledP,
          null,
          children
        ),
        _react2.default.createElement(
          _MorphReplace2.default,
          { width: 24, height: 24 },
          isShow ? _react2.default.createElement(_IconClose3.default, { key: 'close' }) : _react2.default.createElement(_IconMenu3.default, { key: 'menu' })
        ),
        isShow && _react2.default.createElement(
          _Portal2.default,
          null,
          _react2.default.createElement(
            _reactMotionUiPack2.default,
            {
              component: false,
              appear: { opacity: 0.8, translateY: -50 },
              enter: {
                opacity: 1,
                translateY: (0, _spring2.default)(0, { stiffness: 330, damping: 16 })
              }
            },
            _react2.default.createElement(
              Fixed,
              { key: 'Fixed' },
              items.map(function (e) {
                return _react2.default.createElement(HandleHideNavItem, Object.assign({}, e, { onHide: onHide }));
              })
            )
          )
        )
      );
    }
  }]);

  return NavItemBurger;
}(_react2.default.PureComponent);

NavItemBurger.propTypes = {
  children: _propTypes2.default.node,

  // NavItem
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
    children: _propTypes2.default.node.isRequired,
    disabled: _propTypes2.default.bool
  })).isRequired
};
exports.default = NavItemBurger;


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/LandingHeader/NavItemBurger.js
// module id = 577
// module chunks = 3